import React from "react"
import PropTypes from "prop-types"
import { Modal, Table, Typography, Tag, Button, Flex } from "antd"
import { CheckOutlined } from "@ant-design/icons"

const { Title, Text } = Typography

const columns = [
  {
    title: "Experience Name",
    dataIndex: "name",
    key: "name",
    ellipsis: true,
    render: (name) => <Text strong>{name}</Text>
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => {
      const isPublished = String(status).toLowerCase() === "published"
      const display = String(status).charAt(0).toUpperCase() + String(status).slice(1)
      return (
        <Tag color={isPublished ? "green" : "default"} icon={isPublished ? <CheckOutlined /> : null}>
          {display}
        </Tag>
      )
    }
  }
]

const WaiverAssignedExperiencesModal = ({ open, onCancel }) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={600}
      centered
      maskClosable={false}
      footer={null}
      title={
        <Title level={4} style={{ margin: 0 }}>
          Assigned Experiences
        </Title>
      }
    >
      <div style={{ padding: "16px 0" }}>
        <Table
          dataSource={[]}
          rowKey="id"
          columns={columns}
          pagination={false}
          scroll={{ y: 300 }}
          locale={{ emptyText: "No experiences assigned." }}
        />
        <Flex justify="flex-end" style={{ marginTop: 16 }}>
          <Button color="primary" variant="solid" onClick={onCancel}>
            Close
          </Button>
        </Flex>
      </div>
    </Modal>
  )
}

WaiverAssignedExperiencesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default WaiverAssignedExperiencesModal
